/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue} from 'vue-property-decorator'
import {formatDate} from '@/utils/timeFilter'
import {getDownloadFinanceContractById, getFinanceContractInfoById} from '@/api/financial-center'
import {menuBtn} from '@/utils/menu_level2_button'
import {getDepartmentByUserId} from "@/api/common";

@Component({})
export default class ContractStudentInfo extends Vue {
    logShow = true
    contractId = NaN
    contractInfo = null
    status = ''
    isUpdatedData = '0'
    activities = []
    elImageUrls = []
    fileTypeslist: any = [
        {name: '学生合同', val: '0'},
        {name: '代理合同', val: '1'},
        {name: '高校合同', val: '2'}
    ]

    menuBtn = menuBtn
    downloadUrl = ''
    contractCode = ''
    directorDepartmentlName = ''
    isShow = ''

    created() {
        this.contractId = this.$route.query.id as unknown as number
        this.status = this.$route.query.status as string

        this.getFinanceContractInfoById()
    }

    formatDate = formatDate

    async getFinanceContractInfoById() {
        const data: any = await getFinanceContractInfoById({id: this.contractId})
        this.contractInfo = data.financeContract
        this.contractInfo.contractAt = this.contractInfo.contractAt.replace(/&/g, ",");
        this.directorUserIdChange1(this.contractInfo.directorUserId)
        this.downloadUrl = data.financeContract.downloadUrl
        this.contractCode = data.financeContract.code
        this.isShow = data.financeContract.isShow
        this.activities = data.financeContract.messageReviewList
    }

    clickEditButton() {
        if (this.status === '审批中') {
            this.$message.error('审批中，不可编辑')
            return
        }
        this.$router.push({
            path: 'contractAddAgent',
            query: {
                contractId: String(this.contractId),
                isUpdatedData: '0'
            }
        })
    }


    // 预览
    previewContract() {
        window.open(this.downloadUrl, 'blank')
    }

    previewContractUrl() {
        window.open(this.contractInfo.url, 'blank')
    }

    // 查询签署结果
    queryResult() {
        getDownloadFinanceContractById({
            id: this.contractId
        }).then(() => {
            // 重新刷新页面
            location.reload();
        }).catch((err) => {
            console.log(err)
        })
    }

    async directorUserIdChange1(val) {
        if (val) {
            const data: any = await getDepartmentByUserId(val)
            this.contractInfo.deparmentId = data.departmentId
            this.directorDepartmentlName = data.departmentName
        }
    }
}
